import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-Cart',
  standalone: true,
  templateUrl: '../../assets/Cart.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamCartIcon {}
